export const normalizeCardCatalog = (payload = {}) =>
  Object.entries(payload).map(([name, rows]) => ({
    name,
    installments: (Array.isArray(rows) ? rows : [])
      .map((row) => Number(row.cuota ?? row.Cuota))
      .filter(Number.isFinite),
  }));

export const availableCards = (catalog, payment) =>
  catalog.filter((card) =>
    payment === "Debito"
      ? card.installments.includes(0)
      : payment === "Credito"
        ? card.installments.some((installment) => installment > 0)
        : false,
  );

export const availableInstallments = (catalog, cardName, payment) => {
  const card = catalog.find((item) => item.name === cardName);
  if (!card) return [];
  const values = payment === "Debito"
    ? card.installments.filter((value) => value === 0)
    : card.installments.filter((value) => value > 0);
  return [...new Set(values)].sort((a, b) => a - b);
};

export const selectionAfterPaymentChange = (selection, payment) => ({
  ...selection,
  payment,
  card: "",
  installments: null,
  accreditation: "",
  province: "",
});

export const formatArs = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    maximumFractionDigits: 2,
  }).format(number);
};
